module.exports = __webpack_public_path__ + "img/cle_0.11418780.jpg";